export const MIN_PIECES = 1

export const EXPIRATION_DATE_DAYS_THRESHOLD = 7
export const MAX_PIECES = 10
export const MAX_OPTIONS = 5
export const MAX_LEGS = 10
export const COMMODITY_TYPES = [
    {value: 'general', label: 'General Cargo', left: 'bi-box'},
    {value: 'special', label: 'Special Cargo', left: 'bi-bounding-box'}
]

export const SHC_CODES = [
    {value: 'ACT', label: 'Active Temperature Controlled System'},
    {value: 'AOG', label: 'Aircraft on ground'},
    {value: 'ATT', label: 'Goods Attached to Air Waybill'},
    {value: 'AVI', label: 'Live animal'},
    {value: 'BIG', label: 'Outsized'},
    {value: 'BUP', label: 'Bulk Utilization Programme, Shipper/Consignee Handled'},
    {value: 'CAO', label: 'Cargo aircraft only'},
    {value: 'CAT', label: 'Cargo Attendant Accompanying Shipment'},
    {value: 'COL', label: 'Cool Goods  Temperature +2°C to +8°C'},
    {value: 'COM', label: 'Company Mail'},
    {value: 'CRT', label: 'Control Room Temperature +15°C to +25°C'},
    {value: 'DGR', label: 'Dangerous Goods'},
    {value: 'DIP', label: 'Diplomatic mail'},
    {value: 'EAP', label: 'e-freight Consignment with Accompanying Paper Documents'},
    {value: 'EAT', label: 'Foodstuffs'},
    {value: 'EAW', label: 'e-freight Consignment with No Accompanying Paper Documents'},
    {value: 'ECC', label: 'Consignment established with an electronically concluded cargo contract (ECC)'},
    {value: 'ECP', label: 'Consignment established with a paper Air Waybill contract'},
    {value: 'EMD', label: 'Electronic Monitoring Devices in Cargo/Container'},
    {value: 'ERT', label: 'Extended Room Temperature +2°C to +25°C'},
    {value: 'EXP', label: 'Expedited'},
    {value: 'FIL', label: 'Undeveloped/Unexposed film'},
    {value: 'FRI', label: 'Frozen goods subject to veterinary/phytosanitary inspections'},
    {value: 'FRO', label: 'Frozen goods  Temperature below -18°C'},
    {value: 'GOH', label: 'Hanging Garments'},
    {value: 'HAZ', label: 'Hazardous'},
    {value: 'HEA', label: 'Heavy cargo, 150kg and over per piece'},
    {value: 'HEG', label: 'Hatching eggs'},
    {value: 'HUM', label: 'Human remains in coffins'},
    {value: 'LHO', label: 'Living human organs/blood'},
    {value: 'LIC', label: 'License required'},
    {value: 'LTD', label: 'Limited'},
    {value: 'MAL', label: 'Mail'},
    {value: 'MED', label: 'Human Remains'},
    {value: 'MUW', label: 'Munitions of war'},
    {value: 'NSC', label: 'Cargo has not been secured yet for Passenger or All-Cargo Aircraft'},
    {value: 'NWP', label: 'Newspapers, magazines'},
    {value: 'OBX', label: 'Obnoxious cargo'},
    {value: 'OHG', label: 'Overhang item'},
    {value: 'PAC', label: 'Passenger and cargo'},
    {value: 'PEA', label: 'Hunting trophies, skin, hide, and articles made from CITES-listed species'},
    {value: 'PEB', label: 'Animal Products for non-human consumptions'},
    {value: 'PEF', label: 'Flowers'},
    {value: 'PEM', label: 'Meat'},
    {value: 'PEP', label: 'Fruits and Vegetables'},
    {value: 'PER', label: 'Perishable cargo'},
    {value: 'PES', label: 'Fish/Seafood'},
    {value: 'PHY', label: 'Goods subject to phytosanitary inspections'},
    {value: 'PIL', label: 'Pharmaceuticals'},
    {value: 'PIP', label: 'Passive Insulated Packaging'},
    {value: 'QRT', label: 'Quick Ramp Transfer'},
    {value: 'RAC', label: 'Reserved Air Cargo'},
    {value: 'REQ', label: 'Excepted Quantities of Dangerous Goods'},
    {value: 'RRE', label: 'Excepted Quantities of Radioactive Material'},
    {value: 'SCO', label: 'Cargo Secure for All-Cargo Aircraft only'},
    {value: 'SHL', label: 'Save Human Life / Relief'},
    {
        value: 'SHR',
        label: 'Secure for Passenger, All-Cargo and All-Mail Aircraft in Accordance with High Risk Requirements'
    },
    {value: 'SPF', label: 'Laboratory Animals'},
    {value: 'SPX', label: 'Cargo Secure for Passenger and All-Cargo Aircraft'},
    {value: 'SUR', label: 'Surface Transportation'},
    {value: 'SWP', label: 'Sporting Weapons'},
    {value: 'VAL', label: 'Valuable cargo'},
    {value: 'VIC', label: 'Very Important Cargo'},
    {value: 'VOL', label: 'Volume'},
    {value: 'VUN', label: 'Vulnerable Cargo'},
    {value: 'WET', label: 'Shipments of wet material not packed in watertight containers'},
    {value: 'XPS', label: 'Priority small package'}
]

export const DANGEROUS_GOODS_CODES = [
    {value: 'CAO', label: 'Cargo aircraft only'},
    {value: 'ICE', label: 'Carbon dioxide, solid (Dry Ice)'},
    {value: 'DGD', label: "Shipper's Declaration for Dangerous Goods"},
    {value: 'RFL', label: 'Flammable liquid'},
    {value: 'RFG', label: 'Flammable gas'},
    {value: 'RNG', label: 'Non-flammable Non-toxic gas'},
    {value: 'RMD', label: 'Miscellaneous Dangerous Goods'},
    {value: 'RLI', label: 'Fully regulated lithium ion batteries'},
    {value: 'RLM', label: 'Fully regulated lithium metal batteries'},
    {value: 'EBI', label: 'Lithium ion batteries excepted as per Section II of PI 965'},
    {value: 'EBM', label: 'Lithium metal batteries excepted as per Section II of PI 968'},
    {value: 'ELI', label: 'Lithium ion batteries excepted as per Section II of PI 966-967'},
    {value: 'ELM', label: 'Lithium metal batteries excepted as per Section II of PI 969-970'},
    {value: 'REQ', label: 'Dangerous Goods in Excepted Quantities'},
    {value: 'RBM', label: 'Fully regulated lithium metal batteries'},
    {value: 'RBI', label: 'Fully regulated lithium ion batteries'},
    {value: 'RCM', label: 'Corrosive'},
    {value: 'ROP', label: 'Organic peroxide'},
    {value: 'ROX', label: 'Oxidizer'},
    {value: 'RPG', label: 'Toxic gas'},
    {value: 'RPB', label: 'Toxic substance'},
    {value: 'RIS', label: 'Infectious Substance (UN 2814 or UN 2900)'},
    {value: 'RDS', label: 'Biological Substance, Category B'},
    {value: 'MAG', label: 'Magnetized material'},
    {value: 'RCL', label: 'Cryogenic liquids'},
    {value: 'RFW', label: 'Dangerous when wet'},
    {value: 'RFS', label: 'Flammable solid'},
    {value: 'RCX', label: 'Explosives 1.3C'},
    {value: 'RGX', label: 'Explosives 1.3G'},
    {value: 'RXG', label: 'Explosives 1.4G'},
    {value: 'RXE', label: 'Explosives 1.4E'},
    {value: 'RXD', label: 'Explosives 1.4D'},
    {value: 'RXC', label: 'Explosives 1.4C'},
    {value: 'RXB', label: 'Explosives 1.4B'},
    {value: 'RXS', label: 'Explosives 1.4S'},
    {value: 'RRE', label: 'Excepted Packages of Radioactive Material'},
    {value: 'RRW', label: 'Radioactive Material, Category I-White'},
    {value: 'RRY', label: 'Radioactive Material, Categories II and III-Yellow'},
    {value: 'RSC', label: 'Spontaneously combustible'},
    {value: 'RSB', label: 'Polymeric Beads/Plastics Moulding Compound'},
    {value: 'REX', label: 'To be observed for normally forbidden explosives'},
    {value: 'IMP', label: 'Interline Message Procedure'},
    {value: 'RIX', label: 'RIX - Infectious substance'},
    {value: 'RFZ', label: 'RFZ - Flammable (divided red/yellow)'}
]

export const weightUnits = [
    {unit: 'kg', labelUnit: 'Kg'},
    {unit: 'lb', labelUnit: 'Lb'},
    {unit: 'ton', labelUnit: 'T'}
]

export const volumeUnits = [
    {unit: 'cbm', labelUnit: 'm³'},
    {unit: 'cbcm', labelUnit: 'cm³'},
    {unit: 'cuin', labelUnit: 'in³'},
    {unit: 'cuft', labelUnit: 'ft³'},
]

export const distanceUnits = [
    {unit: 'cm', labelUnit: 'cm'},
    {unit: 'mm', labelUnit: 'mm'},
    {unit: 'm', labelUnit: 'm'},
]

export const currencies = [
    {unit: 'usd', labelUnit: 'USD'},
    {unit: 'eur', labelUnit: 'EUR'},
    {unit: 'gbp', labelUnit: 'GBP'},
]

export const UN_CODES = ['UN 1789', 'UN 1791', 'UN 1792', 'UN 1793', 'UN 1794', 'UN 1795', 'UN 1796', 'UN 1797', 'UN 1798', 'UN 1799']

export const AIRCRAFT_MODELS = [
    'A300-600',
    'A300-600F',
    'A300-600R',
    'A300-600ST',
    'A300B4',
    'A310-300',
    'A320-200',
    'A321-200',
    'A330-200',
    'A330-300',
    'A330-700',
    'A340-600',
    'AN-12',
    'AN-124',
    'AN-22',
    'ARJ21-700',
    'ATR42-300',
    'ATR72-200',
    'B.146-200',
    'B.146-300',
    'B707-300',
    'B727-100',
    'B727-200',
    'B737-200',
    'B737-300',
    'B737-400',
    'B737-500',
    'B737-700',
    'B737-800',
    'B747-100',
    'B747-200',
    'B747-300',
    'B747-400',
    'B747-8',
    'B747SR',
    'B757-200',
    'B767-200',
    'B767-300',
    'B777-200',
    'B777-300',
    'BAE-ATP',
    'BEECHCRAFT-99',
    'C408',
    'CL-600-2B19',
    'DC-10-10',
    'DC-10-30',
    'DC-10-40',
    'DC-6',
    'DC-8-50',
    'DC-8-60',
    'DC-8-70',
    'DC-9-10',
    'DC-9-30',
    'DC-9-82',
    'DC-9-83',
    'DHC-8-100',
    'DHC-8-300',
    'DHC-8-400',
    'DO228-200',
    'E120',
    'E190',
    'F27-MK050',
    'IL-18',
    'IL-62',
    'IL-76',
    'IL-78',
    'IL-96',
    'JETSTREAM-3100',
    'L-1011-TRISTAR',
    'L-188A',
    'L-188C',
    'MD-11',
    'MD-88',
    'S2000',
    'S340A',
    'S340B',
    'TU-204-100'
]

export const AIRPORTS = [
    {id: 'AMS-EHAM', city: 'Amsterdam', iata_code: 'AMS'},
    {id: 'CDG-LFPG', city: 'Paris', iata_code: 'CDG'},
    {id: 'HND-RJTT', city: 'Tokyo', iata_code: 'HND'},
    {id: 'JFK-KJFK', city: 'New York', iata_code: 'JFK'},
    {id: 'MAD-LEMD', city: 'Madrid', iata_code: 'MAD'},
    {id: 'MAN-EGCC', city: 'Manchester ', iata_code: 'MAN'},
    {id: 'MIA-KMIA', city: 'Miami', iata_code: 'MIA'},
    {id: 'ORD-KORD', city: 'Chicago', iata_code: 'ORD'},
    {id: 'PEK-ZBAA', city: 'Beijing', iata_code: 'PEK'},
    {id: 'SIN-WSSS', city: 'Singapore', iata_code: 'SIN'},
    {id: 'LHR-EGLL', city: 'London', iata_code: 'LHR'},
    {id: 'TXL-EDDT', city: 'Berlin', iata_code: 'TXL'}
];

export const AIRLINES = [
    {
        id: 'AC-ACA-14',
        code: 'ACA',
        name: 'Air Canada Cargo',
        logo: 'https://logos-world.net/wp-content/uploads/2021/05/Air-Canada-Logo.png'
    },
    {
        id: 'FX-FDX-23',
        code: 'FDX',
        name: 'Fedex',
        logo: 'https://1000marcas.net/wp-content/uploads/2020/01/FedEx-logo-600x338.png'
    },
    {
        id: 'D0-DHK-936',
        code: 'DHL',
        name: 'DHL Air',
        logo: 'https://cdn.worldvectorlogo.com/logos/dhl-1.svg'
    },
    {
        id: '2C-CMA-3',
        code: 'CMA',
        name: 'CMA CGM',
        logo: 'https://banner2.cleanpng.com/20181127/ebp/kisspng--1713917662586.webp'
    },
    {
        id: 'CX-CPA-45',
        code: 'CTH',
        name: 'Cathay Cargo',
        logo: 'https://www.cmgassets.com/s3fs-public/styles/article_node_main_image/public/2024-04/cathay-cargo_master-logo_vertical-green-english-scaled.jpg.webp'
    },
    {
        id: 'LH-DLH-220',
        code: 'DLH',
        name: 'Lufthansa',
        logo: 'https://images.seeklogo.com/logo-png/8/1/lufthansa-cargo-logo-png_seeklogo-86166.png'
    },
    {
        id: 'LH-GEC-020',
        code: 'DLH',
        name: 'Lufthansa Cargo',
        logo: 'https://images.seeklogo.com/logo-png/8/1/lufthansa-cargo-logo-png_seeklogo-86166.png'
    }
]

export const SUBMITTED_BADGES = {
    QUOTED: 'text-sky-400',     // blue dot
    VIEWED: 'text-amber-400',   // orange dot
    DECLINED: 'text-rose-500',  // red dot
    PENDING: 'text-gray-400'    // gray dot
}

export const MESSAGES_STATUS_THEMES = {
    COMPLETED: {
        bgClass: 'bg-green-50 border-green-300',
        color: 'success',              // DaisyUI color name
        btn: 'btn-success',
        iconClass: 'text-success'
    },
    ENGAGED: {
        bgClass: 'bg-blue-50 border-blue-300',
        color: 'accent',
        btn: 'btn-accent',
        iconClass: 'text-accent'
    },
    PENDING: {
        bgClass: 'bg-gray-50 border-gray-300',
        color: 'neutral',
        btn: 'btn-neutral',
        iconClass: 'text-neutral'
    }
}

export const STATUS_THEMES = {
    draft: {
        badges: ['DRAFT'],
        bgClass: 'bg-orange-50 border-orange-300',
        color: 'warning',
        iconClass: 'text-warning',
        btn: 'btn-warning',
        message: 'Your request has not been completed',
        action: 'Complete request',
        icon: 'bi bi-exclamation-triangle-fill'
    },
    submitted: {
        badges: ['SUBMITTED'],
        bgClass: 'bg-blue-50 border-blue-300',
        color: 'primary',
        btn: 'btn-primary',
        message: 'Your request has been submitted',
        stats: {sent: 0, viewed: 0, quotes: 0, declined: 0},
        iconClass: 'text-primary',
        action: 'Edit',
        icon: 'bi bi-send'
    },
    viewed: {
        badges: ['VIEWED'],
        bgClass: 'bg-blue-50 border-blue-300',
        color: 'primary',
        btn: 'btn-primary',
        message: 'Your request has been viewed by an airline',
        icon: 'bi bi-eye'
    },
    quoted: {
        badges: ['quoted'],
        bgClass: 'bg-blue-50 border-blue-300',
        color: 'primary',
        btn: 'btn-primary',
        message: 'Your request has recieved a quote from an airline',
        icon: 'bi bi-eye'
    },
    updated: {
        badges: ['UPDATED', 'SUBMITTED'],
        bgClass: 'bg-blue-50 border-blue-300',
        color: 'info',
        btn: 'btn-info',
        message: 'Your have received a quote by an airline',
        stats : {sent: 0, viewed: 0, quotes: 0, declined: 0},
        iconClass: 'text-info',
        icon: 'bi bi-file-bar-graph-fill'
    },
    improvement: {
        badges: ['IMPROVEMENT REQUEST', 'SUBMITTED'],
        bgClass: 'bg-slate-100 border-slate-300',
        color: 'secondary',
        btn: 'btn-secondary',
        iconClass: 'text-secondary'
    },
    accepted: {
        badges: ['ACCEPTED'],
        bgClass: 'bg-green-50 border-green-300',
        color: 'success',
        btn: 'btn-success',
        message: 'Your contract has been signed',
        iconClass: 'text-success',
        icon: 'bi bi-check-circle-fill'
    },
    'pending-contract': {
        badges: ['PENDING CONTRACT'],
        bgClass: 'bg-green-50 border-green-300',
        color: 'success',
        btn: 'btn-success',
        message: 'Your quote has been accepted. Pending contract',
        iconClass: 'text-success',
        icon: 'bi bi-check-circle-fill'
    },
    pending_to_view: {
        badges: ['PENDING TO VIEW', 'SUBMITTED'],
        bgClass: 'bg-blue-50 border-blue-300',
        color: 'accent',
        btn: 'btn-accent',
        iconClass: 'text-accent'
    },
    expired: {
        badges: ['EXPIRED'],
        bgClass: 'bg-gray-50 border-gray-300',
        color: 'neutral',
        btn: 'btn-neutral',
        iconClass: 'text-neutral'
    },
    declined: {
        badges: ['IMPROVED-DECLINED','DECLINED'],
        bgClass: 'bg-red-50 border-red-300',
        color: 'error',
        btn: 'btn-warning',
        message: 'Your request has been declined',
        iconClass: 'text-error',
        icon: 'bi bi-x-octagon-fill'
    },
    cancelled: {
        badges: ['CANCELLED'],
        bgClass: 'bg-red-50 border-red-300',
        color: 'error',
        btn: 'btn-warning',
        message: 'Your request has been cancelled',
        iconClass: 'text-error',
        icon: 'bi bi-x-circle-fill'
    }
}

export const MONTHS = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
]

export const AIRPORTS_LOCATIONS = {
    MAD: [40.4722, -3.5608],      // Madrid–Barajas
    MIA: [25.7933, -80.2906],     // Miami International
    BCN: [41.2974, 2.0833],       // Barcelona–El Prat
    OPO: [41.2422, -8.6781],      // Porto Airport
    CDG: [49.0097, 2.5479],       // Paris Charles de Gaulle
    LHR: [51.4700, -0.4543],      // London Heathrow
    JFK: [40.6413, -73.7781],     // New York JFK
    DXB: [25.2528, 55.3644],      // Dubai International
    FRA: [50.0333, 8.5706],       // Frankfurt Airport
    MAN: [53.3651, -2.2729],      // Manchester Airport
    SYD: [-33.9399, 151.1753],    // Sydney Kingsford Smith
    SIN: [1.3644, 103.9915],      // Singapore Changi
}

export const ICON_STATUS_MAP = {
    draft: 'bi-dot',
    accepted: 'bi-check-lg',
    submitted: 'bi-dot',
    improvement: 'bi-dot',
    pending_to_sign: 'bi-exclamation-lg',
    pending_to_view: 'bi-exclamation-lg',
    expired: 'bi-dot',
    declined: 'bi-x',
}
export const STATUS_MAP = {
    draft: ['warning', 'bg-warning text-white', 'badge badge-xs badge-warning'],
    on_schedule: ['primary', 'bg-primary text-white', 'badge badge-xs badge-primary'],
    submitted: ['primary', 'bg-primary text-white', 'badge badge-xs badge-primary'],
    pending: ['primary', 'bg-primary text-white', 'badge badge-xs badge-primary'],
    on_route: ['primary', 'bg-primary text-white', 'badge badge-xs badge-primary'],
    updated: ['info', 'bg-info text-white', 'badge badge-xs badge-info'],
    quoted: ['info', 'bg-info text-white', 'badge badge-xs badge-info'],
    improved_requested: ['primary', 'bg-primary text-white', 'badge badge-xs badge-primary'],
    accepted: ['success', 'bg-success text-white', 'badge badge-xs badge-success'],
    arrived: ['success', 'bg-success text-white', 'badge badge-xs badge-success'],
    expired: ['light', 'bg-light text-light', 'badge badge-xs badge-light'],
    completed: ['light', 'bg-light text-light', 'badge badge-xs badge-light'],
    pending_contract:['success', 'bg-success text-white', 'badge badge-xs badge-success'],
    pending_to_sign: ['warning', 'bg-warning text-white', 'badge badge-xs badge-warning'],
    pending_to_view: ['accent', 'bg-accent text-white', 'badge badge-xs badge-accent'],
    departed: ['accent', 'bg-accent text-white', 'badge badge-xs badge-accent'],
    delayed: ['warning', 'bg-warning text-white', 'badge badge-xs badge-warning'],
    viewed: ['primary', 'bg-primary text-white', 'badge badge-xs badge-primary'],
    improved_declined: ['warning', 'bg-warning text-white', 'badge badge-xs badge-warning'],
    declined: ['error', 'bg-error text-white', 'badge badge-xs badge-error'],
    refused: ['error', 'bg-error text-white', 'badge badge-xs badge-error'],
    cancelled: ['error', 'bg-error text-white', 'badge badge-xs badge-error'],
}